import React, { useContext } from "react";
import "App.scss";
import { CssBaseline } from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Provider } from "react-redux";
import configStore from "redux/store";
import NotFound from "components/NotFound";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import * as Pages from "./pdf-lib";
import { TextField, MenuItem } from "@material-ui/core";
import { ThemeContext } from "index";
import Icon from "components/common_components/Icon";
import AppContext from "AppContext";
import { Buffer } from "buffer";

window.Buffer = window.Buffer || Buffer;

export default function Pocs() {
    const { theme, setTheme } = useContext(ThemeContext);
    const themes = ["blue", "gray"];

    const onThemeChange = (event) => setTheme(event.target.value);

    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <AppContext.Provider
                value={{
                    configurations: [{ id: "general_currency", value: "USD" }],
                }}
            >
                <Provider store={configStore.store}>
                    <div
                        style={{
                            width: "100%",
                            minHeight: 50,
                            marginBottom: 20,
                            padding: 10,
                            backgroundColor: "gainsboro",
                            borderBottom: "silver 1px solid",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Icon name="theme" size="xlg" color="secondary" />
                        <TextField select value={theme} onChange={onThemeChange}>
                            {themes.map((t, index) => (
                                <MenuItem key={index} value={t}>
                                    {t.toUpperCase()}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                    <Router>
                        <Switch>
                            <Route path="/fill-form" component={Pages.FillForm} />
                            <Route path="/" component={null} />
                            <Route component={NotFound} />
                        </Switch>
                    </Router>
                </Provider>
            </AppContext.Provider>
            <CssBaseline />
        </MuiPickersUtilsProvider>
    );
}
